import api from "./Client";
import { SecureStorage } from "../storage/SecureStorage";
import { CUSTOMER_SESSION_ENDPOINT } from "../config";

export interface User {
  id: number;
  fullName: string;
  email: string;
  phone?: string;
  sex?: string;
  dateOfBirth?: string;
  postcode?: number | null;
  postAddress?: string;
  dni?: string | null;
  profilePictureName?: string | null;
  profilePictureUrl?: string | null;
}

/** Carga el perfil completo desde backend y lo guarda en SecureStorage */
export async function fetchUserProfile(userId: number): Promise<User> {
  void userId;
  const res = await api.get<{ user: User }>(CUSTOMER_SESSION_ENDPOINT);
  const user = res.data.user;
  await SecureStorage.saveUser(user);
  return user;
}
